export enum TextAlignment {
  Left = "left",
  Center = "center",
  Right = "right",
  // TypeScript won't take Justified as an option
}
